//isWindows = -1 < navigator.platform.indexOf("Win"), isWindows ? (0 != $(".sidebar").length && new PerfectScrollbar(".sidebar"), 0 != $(".sidebar-wrapper").length && new PerfectScrollbar(".sidebar-wrapper"), 0 != $(".main-panel").length && new PerfectScrollbar(".main-panel"), 0 != $(".main").length && new PerfectScrollbar("main"), 0 != $(".page-header").length && new PerfectScrollbar("page-header"), 0 != $(".dropdown-menu").length && new PerfectScrollbar("dropdown-menu"), $("html").addClass("perfect-scrollbar-on")) : $("html").addClass("perfect-scrollbar-off");
//isWindows = -1 < navigator.platform.indexOf("Win"), isWindows ? (0 != $(".sidebar").length && new PerfectScrollbar(".sidebar"), 0 != $(".sidebar-wrapper").length && new PerfectScrollbar(".sidebar-wrapper"), 0 != $(".main-panel").length && new PerfectScrollbar(".main-panel"), 0 != $(".main").length && new PerfectScrollbar("main"), 0 != $(".page-header").length && new PerfectScrollbar("page-header"), $("html").addClass("perfect-scrollbar-on")) : $("html").addClass("perfect-scrollbar-off");
isWindows = -1 < navigator.platform.indexOf("Win"), isWindows ? (0 != $(".sidebar").length && new PerfectScrollbar(".sidebar"), 0 != $(".sidebar-wrapper").length && new PerfectScrollbar(".sidebar-wrapper"), 0 != $(".main-panel").length && new PerfectScrollbar(".main-panel"), 0 != $(".main").length && new PerfectScrollbar("main"), $("html").addClass("perfect-scrollbar-on")) : $("html").addClass("perfect-scrollbar-off");
var breakCards = !0,
    searchVisible = 0,
    transparent = !0,
    transparentDemo = !0,
    fixedTop = !1,
    mobile_menu_visible = 0,
    mobile_menu_initialized = !1,
    toggle_initialized = !1,
    bootstrap_nav_initialized = !1,
    seq = 0,
    delays = 80,
    durations = 500,
    seq2 = 0,
    delays2 = 80,
    durations2 = 500,
    collapse = $(".collapse");

function debounce(a, n, i) {
    var o;
    return function () {
        var e = this,
            t = arguments;
        clearTimeout(o), o = setTimeout(function () {
            o = null, i || a.apply(e, t)
        }, n), i && !o && a.apply(e, t)
    }
}
$(document).ready(function () {
    $sidebar = $(".sidebar"), window_width = $(window).width(), $("body").bootstrapMaterialDesign({
        autofill: !1
    }), md.initSidebarsCheck(), window_width = $(window).width(), md.checkSidebarImage(), md.initMinimizeSidebar(), $(".dropdown-menu a.dropdown-toggle").on("click", function (e) {
        var t = $(this),
            a = $(this).offsetParent(".dropdown-menu");
        return $(this).next().hasClass("show") || $(this).parents(".dropdown-menu").first().find(".show").removeClass("show"), $(this).next(".dropdown-menu").toggleClass("show"), $(this).closest("a").toggleClass("open"), $(this).parents("a.dropdown-item.dropdown.show").on("hidden.bs.dropdown", function (e) {
            $(".dropdown-menu .show").removeClass("show")
        }), a.parent().hasClass("navbar-nav") || t.next().css({
            top: t[0].offsetTop,
            left: a.outerWidth() - 4
        }), !1
    }), collapse.on("show.bs.collapse", function () {
        $(this).parent().siblings().children(".collapse").each(function () {
            $(this).collapse("hide")
        })
    }), 0 != $(".selectpicker").length && $(".selectpicker").selectpicker(), 0 != $('[data-toggle="tooltip"]').length && $('[data-toggle="tooltip"]').tooltip(), 0 != $('[data-toggle="popover"]').length && $('[data-toggle="popover"]').popover();
    var e = $(".tagsinput").data("color");
    0 != $(".tagsinput").length && $(".tagsinput").tagsinput(), $(".bootstrap-tagsinput").addClass(e + "-badge"), $(".select").dropdown({
        dropdownClass: "dropdown-menu",
        optionClass: ""
    }), $(".form-control").on("focus", function () {
        $(this).parent(".input-group").addClass("input-group-focus")
    }).on("blur", function () {
        $(this).parent(".input-group").removeClass("input-group-focus")
    }), 1 == breakCards && $('[data-header-animation="true"]').each(function () {
        $(this);
        var t = $(this).parent(".card");
        t.find(".fix-broken-card").click(function () {
            console.log(this);
            var e = $(this).parent().parent().siblings(".card-header, .card-header-image");
            e.removeClass("hinge").addClass("animate__fadeInDown"), t.attr("data-count", 0), setTimeout(function () {
                e.removeClass("animate__fadeInDown animate__animated")
            }, 480)
        }), t.mouseenter(function () {
            var e = $(this);
            hover_count = parseInt(e.attr("data-count"), 10) + 1 || 0, e.attr("data-count", hover_count), 20 <= hover_count && $(this).children(".card-header, .card-header-image").addClass("hinge animated")
        })
    }), $('input[type="checkbox"][required="true"], input[type="radio"][required="true"]').on("click", function () {
        $(this).hasClass("error") && $(this).closest("div").removeClass("has-error")
    })
}), $(document).on("click", ".navbar-toggler", function () {
    var e;
    $toggle = $(this), mobile_menu_visible = 1 == mobile_menu_visible ? ($("html").removeClass("nav-open"), $(".close-layer").remove(), setTimeout(function () {
        $toggle.removeClass("toggled")
    }, 400), 0) : (setTimeout(function () {
        $toggle.addClass("toggled")
    }, 430), e = $('<div class="close-layer"></div>'), 0 != $("body").find(".main-panel").length ? e.appendTo(".main-panel") : $("body").hasClass("off-canvas-sidebar") && e.appendTo(".wrapper-full-page"), setTimeout(function () {
        e.addClass("visible")
    }, 100), e.click(function () {
        $("html").removeClass("nav-open"), mobile_menu_visible = 0, e.removeClass("visible"), setTimeout(function () {
            e.remove(), $toggle.removeClass("toggled")
        }, 400)
    }), $("html").addClass("nav-open"), 1)
}), md = {
    misc: {
        navbar_menu_visible: 0,
        active_collapse: !0,
        disabled_collapse_init: 0
    },
    checkSidebarImage: function () {
        $sidebar = $(".sidebar"), image_src = $sidebar.data("image"), void 0 !== image_src && (sidebar_container = '<div class="sidebar-background" style="background-image: url(' + image_src + ') "/>', $sidebar.append(sidebar_container))
    },
    showNotification: function (e, t) {
        type = ["", "info", "danger", "success", "warning", "rose", "primary"], color = Math.floor(6 * Math.random() + 1), $.notify({
            icon: "add_alert",
            message: "Welcome to <b>AK-LG</b>"
        }, {
            type: type[color],
            timer: 3e3,
            placement: {
                from: e,
                align: t
            }
        })
    },
    initSidebarsCheck: function () {
        $(window).width() <= 991 && 0 != $sidebar.length && md.initRightMenu()
    },
    initMinimizeSidebar: function () {
        $("#minimizeSidebar").click(function () {
            $(this);
            1 == md.misc.sidebar_mini_active ? ($("body").removeClass("sidebar-mini"), md.misc.sidebar_mini_active = !1) : ($("body").addClass("sidebar-mini"), md.misc.sidebar_mini_active = !0);
            var e = setInterval(function () {
                window.dispatchEvent(new Event("resize"))
            }, 180);
            setTimeout(function () {
                clearInterval(e)
            }, 1e3)
        })
    },
    checkScrollForTransparentNavbar: debounce(function () {
        260 < $(document).scrollTop() ? transparent && (transparent = !1, $(".navbar-color-on-scroll").removeClass("navbar-transparent")) : transparent || (transparent = !0, $(".navbar-color-on-scroll").addClass("navbar-transparent"))
    }, 17),
    initRightMenu: debounce(function () {
        $sidebar_wrapper = $(".sidebar-wrapper"), mobile_menu_initialized ? 991 < $(window).width() && ($sidebar_wrapper.find(".navbar-form").remove(), $sidebar_wrapper.find(".nav-mobile-menu").remove(), mobile_menu_initialized = !1) : ($navbar = $("nav").find(".navbar-collapse").children(".navbar-nav"), mobile_menu_content = "", nav_content = $navbar.html(), nav_content = '<ul class="nav navbar-nav nav-mobile-menu">' + nav_content + "</ul>", navbar_form = $("nav").find(".navbar-form").get(0).outerHTML, $sidebar_nav = $sidebar_wrapper.find(" > .nav"), $nav_content = $(nav_content), $navbar_form = $(navbar_form), $nav_content.insertBefore($sidebar_nav), $navbar_form.insertBefore($nav_content), $(".sidebar-wrapper .dropdown .dropdown-menu > li > a").click(function (e) {
            e.stopPropagation()
        }), window.dispatchEvent(new Event("resize")), mobile_menu_initialized = !0)
    }, 200)
};